import { BaseAction, actionTypes } from 'redux/actions';
import { PolicyAddEnListReq, VehicleBrand } from 'bff/models/product';
import { GameChkqualifyResp } from 'bff/models/game/gameChkqualify';

export const setGameQualifyModalVisibleAction = (visible: boolean, gamePoi?: string, applyNo?: string, checkResult?: GameChkqualifyResp): BaseAction => ({
  type: actionTypes.MODAL.SET_GAME_QUALIFY_MODAL_VISIBLE,
  payload: {
    visible,
    gamePoi,
    applyNo,
    checkResult
  }
});

export const setCaptchaErrorModalVisibleAction = (visible: boolean): BaseAction => ({
  type: actionTypes.MODAL.SET_CAPTCHA_ERROR_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

export const setCaptchaSendModalVisibleAction = (visible: boolean): BaseAction => ({
  type: actionTypes.MODAL.SET_CAPTCHA_SEND_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

export const setCaptchaReturnModalVisibleAction = (visible: boolean): BaseAction => ({
  type: actionTypes.MODAL.SET_CAPTCHA_RETURN_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

export const setGuardianshipStatementModalVisibleAction = (visible: boolean): BaseAction => ({
  type: actionTypes.MODAL.SET_GUARDIANSHIP_STATEMENT_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

export const setInfoModalVisibleAction = (visible: boolean, title?: string, content?: string): BaseAction => ({
  type: actionTypes.MODAL.SET_INFO_MODAL_VISIBLE,
  payload: {
    visible: visible,
    title: title,
    content: content
  }
});

/**
 * @description 新增英文投保證明名冊 Modal
*/
export const setFillPassportModalVisibleAction = (visible: boolean, insureds?: any[], serialNo?: string, setAddEnListReq?: (data: PolicyAddEnListReq) => void): BaseAction => ({
  type: actionTypes.MODAL.SET_FILL_PASSPORT_MODAL_VISIBLE,
  payload: {
    visible: visible,
    insureds: insureds,
    serialNo: serialNo,
    setAddEnListReq: setAddEnListReq
  }
});

/**
 * @description loading Modal
*/
export const setLoadingVisible = (visible: boolean, dealing?: boolean, policyperiod?: boolean, petLoading?: boolean): BaseAction => ({
  type: actionTypes.LOADING.SET_LOADING_VISIBLE,
  payload: {
    visible: visible,
    dealing: dealing,
    policyperiod: policyperiod,
    petLoading: petLoading
  }
});

/**
 * @description 保單規則檢核錯誤 Modal
*/
export const setRuleValidErrorModalVisible = (visible: boolean, errorMsgs: string[]): BaseAction => ({
  type: actionTypes.MODAL.SET_RULE_VALID_ERROR_MODAL_VISIBLE,
  payload: {
    visible: visible,
    errorMsgs: errorMsgs
  }
});

/**
 * @description 投保作業 - 汽車、機車險 - 如何填寫 Modal
 * @param visible Modal 能見度
*/
export const setFillExampleModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_FILL_EXAMPLE_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

/**
 * @description 投保作業 - 汽車、機車險 - 選擇廠牌 Modal
 * @param visible Modal 能見度
 * @param vehicleBrands 廠牌資料
 * @param selectItem 選取的廠牌
 */
export const setSelectVehicleBrandsModalVisibleAction = (visible: boolean, vehicleBrands?: VehicleBrand[], selectItem?: VehicleBrand) => ({
  type: actionTypes.MODAL.SET_SELECT_VEHICLE_BRANDS_MODAL_VISIBLE,
  payload: {
    visible: visible,
    vehicleBrands: vehicleBrands,
    selectItem: selectItem
  }
});

/**
 * @description 投保作業 - 汽車、機車險 - 選擇車型 Modal
 * @param visible Modal 能見度
 */
export const setSelectVehicleModelsModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_SELECT_VEHICLE_MODELS_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

export const setSelectInsuranceTypeModalVisibleAction = (visible: boolean, memberId?: string, nationalityType?: string): BaseAction => ({
  type: actionTypes.MODAL.SET_SELECT_INSURANCE_TYPE_MODAL_VISIBLE,
  payload: {
    visible: visible,
    memberId: memberId,
    nationalityType: nationalityType
  }
});

/**
 * @description 會員登入檢核相關欄位值
 * @param visible 是否顯示
 * @param title 訊息標頭
 * @param content 訊息內容
 * @param fieldNames 需顯示錯誤訊息的欄位
 */
export const setMemberInfoErrorModalVisible = (visible: boolean, title?: string, content?: string, fieldNames?: string[]): BaseAction => ({
  type: actionTypes.MODAL.SET_MEMBER_INFO_ERROR_MODAL_VISIBLE,
  payload: {
    visible: visible,
    title: title,
    content: content,
    fieldNames: fieldNames
  }
});

/**
 * @description 會員登入 Modal
 * @param visible 是否顯示
 */
export const setLoginModalVisible = (visible: boolean): BaseAction => ({
  type: actionTypes.MODAL.SET_LOGIN_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

export const setVetHospitalModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_VET_HOSPITAL_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

/**
 * @description 投保作業 - 旅遊險 - 投保小幫手 Modal
 * @param visible Modal 能見度
*/
export const setInsureHelperModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_INSURE_HELPER_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

/**
 * @description 投保作業 - 旅遊險 - 海外救援 Modal
 * @param visible Modal 能見度
*/
export const setAbroadModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_ABROAD_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

/**
 * @description 投保作業 - 旅遊險 - 說明 Modal
 * @param visible Modal 能見度
*/
export const setExplainModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_EXPLAIN_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

/**
 * @description 投保作業 - 旅遊險 - 商品特色說明 Modal
 * @param visible Modal 能見度
*/
export const setProductExplainModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_PRODUCT_EXPLAIN_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});

/**
 * @description 投保作業 - 旅遊險 - 投保資料確認 Modal
 * @param visible Modal 能見度
 */
export const setConfirmModalVisibleAction = (visible: boolean) => ({
  type: actionTypes.MODAL.SET_CONFIRM_MODAL_VISIBLE,
  payload: {
    visible: visible
  }
});
